import { SparklesIcon } from "@heroicons/react/16/solid";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

const HowItWorks = () => (
  <section
    id="how-it-works"
    className="w-full overflow-x-hidden lg:px-21 md:px-10 py-5 px-4"
  >
    <div className="max-w-7xl mx-auto text-center mb-8">
      <h2 className="md:text-4xl text-3xl font-semibold text-gray-900 mb-4">
        How It Works
      </h2>
      <p className="md:text-xl text-base font-normal text-gray-500">
        Three simple steps to track your service order
      </p>
    </div>

    <div className="grid md:grid-cols-2 md:gap-15 gap-6 md:max-w-7xl max-w-md mx-auto">
      <div className="bg-white px-5 py-7 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
        <h3 className="text-2xl font-medium text-gray-800 mb-2">
          Enter Order Details
        </h3>
        <p className="text-base font-normal text-gray-500 mb-8 leading-relaxed">
          Provide your order ID, part number, and vehicle information.
        </p>
        <div className="mt-auto bg-white rounded-xl border border-gray-50">
          <div className="flex flex-col justify-end gap-4">
            <div className="w-2/3">
              <label className="text-sm font-normal text-gray-800 mb-2">
                eBay Order ID
              </label>
              <div className="text-sm font-medium p-3 rounded-xl text-gray-400 border border-gray-300">
                12-34567-89012
              </div>
            </div>
            <div className="w-2/3 ml-auto">
              <label className="text-sm font-normal text-gray-800 mb-2">
                Service Type
              </label>
              <div className="text-sm font-medium p-3 rounded-xl text-gray-400 border border-gray-300 flex justify-between">
                Select service type{" "}
                <span>
                  <ChevronDownIcon className="w-4 h-4 text-gray-500" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white px-5 py-7 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
        <h3 className="text-2xl font-medium text-gray-800 mb-2">
          Upload & Ship
        </h3>
        <p className="text-base font-normal text-gray-500 mb-8 leading-relaxed">
          Add your tracking information, then send your item in for service.
        </p>
        <div className="flex flex-col items-end gap-3">
          <div className="bg-[#0066FF] text-white px-5 py-4 rounded-full text-sm font-normal">
            Yes, I've shipped it
          </div>
          <div className="flex items-center gap-2 self-start w-full">
            <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white text-3xl">
              <SparklesIcon className="w-7 h-7" />
            </div>
            <div className="flex-1 bg-gray-50 p-2 rounded border border-gray-100 text-sm font-normal text-gray-800">
              Not yet
            </div>
          </div>
        </div>
      </div>

      {/* <div className="bg-white px-5 py-7 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
        <h3 className="text-2xl font-medium text-gray-800 mb-2">
          Track Progress
        </h3>
        <p className="text-base font-normal text-gray-500 mb-8 leading-relaxed">
          Follow and be informed at every stage of your service, from arrival to
          return delivery, in your dashboard.
        </p>
        <div className="space-y-4">
          <div className="flex justify-between text-sm font-normal text-gray-400 mb-1">
            <span>Service Process</span>
            <span>35%</span>
          </div>
          <div className="w-full bg-gray-100 h-5 rounded-full overflow-hidden">
            <div className="bg-linear-to-b from-[#53A0FF] to-[#0258C3] h-full w-[35%] rounded-full"></div>
          </div>
          <div className="space-y-5 pt-2">
            <div className="flex items-center gap-3 text-base font-normal text-gray-500">
              <CheckCircleIcon className="w-6 h-6 text-green-500" />
              Item Received
            </div>
            <div className="flex items-center gap-3 text-base font-normal text-gray-500">
              <span className="flex h-6 w-6 rounded-full border border-blue-500 items-center justify-center">
                <span className="h-2 w-2 bg-blue-600 rounded-full"></span>
              </span>
              Repair in Progress
            </div>
            <div className="flex items-center gap-3 text-base font-normal text-gray-500">
              <span className="flex h-6 w-6 rounded-full bg-gray-200 items-center justify-center">
                <ShieldCheckIcon className="w-4 h-4 rounded-full text-gray-500" />
              </span>
              Item Received
            </div>
            <div className="flex items-center gap-3 text-base font-normal text-gray-500">
              <span className="flex h-6 w-6 rounded-full bg-gray-200 items-center justify-center">
                <TruckIcon className="w-4 h-4 rounded-full text-gray-500" />
              </span>
              Item Shipped Back
            </div>
            <div className="flex items-center gap-3 text-base font-normal text-gray-500">
              <span className="flex h-6 w-6 rounded-full bg-gray-200 items-center justify-center">
                <CheckBadgeIcon className="w-4 h-4 rounded-full text-gray-500" />
              </span>
              Item Shipped Back
            </div>
          </div>
        </div>
      </div> */}
    </div>
  </section>
);

export default HowItWorks;
